import React, { Component } from "react";
import PanelTitle from "./PanelTitle";
import PanelBody from "./PanelBody";
import PanelFooter from "./PanelFooter";

export default class Panel extends Component {
  renderPanelTitle = () => {
    const { children } = this.props;
    return React.Children.map(children, child => {
      if (child.type === PanelTitle) {
        return child;
      } else {
        return null;
      }
    });
  };
  renderPanelBody = () => {
    const { children } = this.props;
    return React.Children.map(children, child => {
      if (child.type === PanelBody) {
        return child;
      } else {
        return null;
      }
    });
  };
  renderPanelFooter = () => {
    const { children } = this.props;
    return React.Children.map(children, child => {
      if (child.type === PanelFooter) {
        return child;
      } else {
        return null;
      }
    });
  };
  render() {
    return (
      <div class="panel panel-default">
        {this.renderPanelTitle()}
        {this.renderPanelBody()}
        {this.renderPanelFooter()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/UI/Panel/index.js